import { createGetApiCall } from '../../../Helpers/api'

export const getTextRoute = ccrid => `/api/rest/cas/textview?ccrid=${ccrid}`

export default {
  getText: ccrid => createGetApiCall(getTextRoute(ccrid))(),
}
